import { z } from "zod";
import { EDocumentKey } from "../EDocumentKey";

export const documentExpirationTaskPayloadSchema = z.object({
  LIST_A: z
    .object({
      document_key: z.nativeEnum(EDocumentKey),
      expiration_date: z.string().optional(),
    })
    .optional(),
  LIST_C: z
    .object({
      document_key: z.nativeEnum(EDocumentKey),
      expiration_date: z.string().optional(),
    })
    .optional(),
});
